import { baseApi, API_TAGS } from '@/shared/api';
import { createDashboardEndpointBuilder, type DashboardOptionsResponse } from '@/entities/dashboard';

const optionsEndpoint = createDashboardEndpointBuilder('/options');

export const optionsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getDashboardOptions: builder.query<DashboardOptionsResponse, void>({
      query: () => ({
        url: optionsEndpoint('')
      }),
      providesTags: [API_TAGS.DASHBOARD, API_TAGS.OPTIONS]
    })
  })
});

export const { useGetDashboardOptionsQuery } = optionsApi;
